import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../../../common/models';

export class AllocationViewUliCarrierModel {
  carrierExtId: string = null;
  carrierName: string = null;
  carrierNumber: string = null;

  constructor(params?: AllocationViewUliCarrierModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliCarrierForm {
  constructor(
    model?: AllocationViewUliCarrierModel,
    public carrierExtId: ControlProperty<string> = [model.carrierExtId, [Validators.required]],
    public carrierName: ControlProperty<string> = [model.carrierName, [Validators.required]],
    public carrierNumber: ControlProperty<string> = model.carrierName,
  ) {}
}
